/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unused-vars */

import Repository from '../types/Repository';
import { RestResponse } from '../types/response/RestResponse';

export default abstract class AbstractRestRepository<T> implements Repository<T> {
  protected unpackResponseContent<U>(response: RestResponse<U>): U {
    const { result, content } = response.data;
    if (!result.result) {
      throw response;
    }
    return content;
  }

  get(id: number): Promise<T | null> {
    throw new Error('Invalid operation `get()` for type entity');
  }

  getAll(params: Record<string, string | number>): Promise<T[]> {
    throw new Error('Invalid operation `getAll()` for type entity');
  }

  create(entity: T): Promise<T> {
    throw new Error('Invalid operation `create()` for entity');
  }
}
